import * as React from 'react';
import ProactiveWrapper from './Proactive/ProactiveWrapper';
import CarsWrapper from './Cars/CarsWrapper';
import SidebarWrapper from './Sidebar/SidebarWrapper';
import MobileWrapper from './Mobile/MobileWrapper';
import { withMedia } from '../../util/styles';

function ConvoWrapperFactory(props: any) {
    if (props.isMobile && props.settings.messageListType !== 'cars.com') {
        return <MobileWrapper {...props} />;
    }

    switch (props.settings.messageListType) {
        case 'proactive':
            return <ProactiveWrapper {...props} />;
        case 'cars.com':
            return <CarsWrapper {...props} />;
        case 'sidebar':
        default:
            return <SidebarWrapper {...props} />;
    }
}

export default withMedia(ConvoWrapperFactory);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/ConvoWrapperFactory.tsx